"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginModalOptionType = void 0;
const react_1 = __importStar(require("react"));
const provider_type_1 = require("@dcl/schemas/dist/dapps/provider-type");
const ConnectionManager_1 = require("decentraland-connect/dist/ConnectionManager");
const utils_1 = require("decentraland-dapps/dist/containers/LoginModal/utils");
const LoginModal_1 = require("decentraland-ui/dist/components/LoginModal/LoginModal");
Object.defineProperty(exports, "LoginModalOptionType", { enumerable: true, get: function () { return LoginModal_1.LoginModalOptionType; } });
const Modal_1 = require("decentraland-ui/dist/components/Modal/Modal");
const ModalNavigation_1 = require("decentraland-ui/dist/components/ModalNavigation/ModalNavigation");
const ModalContent_1 = __importDefault(require("semantic-ui-react/dist/commonjs/modules/Modal/ModalContent"));
const utils_2 = require("../../context/Auth/utils");
const useAnchor_1 = __importDefault(require("../../hooks/useAnchor"));
const useFormatMessage_1 = __importDefault(require("../../hooks/useFormatMessage"));
const Loader_1 = __importDefault(require("../Progress/Loader"));
const Markdown_1 = __importDefault(require("../Text/Markdown"));
require("decentraland-ui/dist/components/LoginModal/LoginModal.css");
require("./WalletSelectorModal.css");
exports.default = react_1.default.memo(function WalletSelector(props) {
    const l = (0, useFormatMessage_1.default)();
    const [provider, setProvider] = (0, react_1.useState)(LoginModal_1.LoginModalOptionType.METAMASK);
    const [availableProviders, setAvailableProviders] = (0, react_1.useState)(new Set([]));
    // Detect available providers
    (0, react_1.useEffect)(() => {
        var _a;
        return setAvailableProviders(new Set((_a = props.availableProviders) !== null && _a !== void 0 ? _a : ConnectionManager_1.connection.getAvailableProviders()));
    }, [...(props.availableProviders || [])]);
    (0, react_1.useEffect)(() => {
        setProvider((0, utils_1.toModalOptionType)(provider_type_1.ProviderType.INJECTED) || LoginModal_1.LoginModalOptionType.METAMASK);
    }, []);
    const handleConnect = (0, react_1.useCallback)((providerType, chainId) => {
        if (props.onConnect) {
            props.onConnect(providerType, chainId);
        }
    }, [props.onClose]);
    const open = (0, useAnchor_1.default)('https://metamask.io/download.html');
    const handleConnectInjected = (0, react_1.useCallback)(() => {
        if (availableProviders.has(provider_type_1.ProviderType.INJECTED)) {
            handleConnect(provider_type_1.ProviderType.INJECTED, (0, utils_2.getChainId)());
        }
        else {
            open();
        }
    }, [handleConnect, open, availableProviders]);
    const handleConnectFortmatic = (0, react_1.useCallback)(() => handleConnect(provider_type_1.ProviderType.FORTMATIC, (0, utils_2.getChainId)()), [handleConnect]);
    const handleConnectWalletConnect = (0, react_1.useCallback)(() => handleConnect(props.disabledWalletConnect2
        ? provider_type_1.ProviderType.WALLET_CONNECT
        : provider_type_1.ProviderType.WALLET_CONNECT_V2, (0, utils_2.getChainId)()), [handleConnect, props.disabledWalletConnect2]);
    const handleConnectWalletLink = (0, react_1.useCallback)(() => handleConnect(provider_type_1.ProviderType.WALLET_LINK, (0, utils_2.getChainId)()), [handleConnect]);
    return (react_1.default.createElement(Modal_1.Modal, { open: props.open, className: `dcl login-modal`, mountNode: props.mountNode },
        react_1.default.createElement(ModalNavigation_1.ModalNavigation, { title: l('@growth.WalletSelector.title'), subtitle: l('@growth.WalletSelector.subtitle'), onClose: props.onClose }),
        react_1.default.createElement(ModalContent_1.default, null,
            react_1.default.createElement(LoginModal_1.LoginModal.Option, { type: provider, onClick: handleConnectInjected }),
            availableProviders.has(provider_type_1.ProviderType.FORTMATIC) && (react_1.default.createElement(LoginModal_1.LoginModal.Option, { type: LoginModal_1.LoginModalOptionType.FORTMATIC, onClick: handleConnectFortmatic })),
            availableProviders.has(provider_type_1.ProviderType.WALLET_CONNECT) && (react_1.default.createElement(LoginModal_1.LoginModal.Option, { type: LoginModal_1.LoginModalOptionType.WALLET_CONNECT, onClick: handleConnectWalletConnect })),
            availableProviders.has(provider_type_1.ProviderType.WALLET_LINK) && (react_1.default.createElement(LoginModal_1.LoginModal.Option, { type: LoginModal_1.LoginModalOptionType.WALLET_LINK, onClick: handleConnectWalletLink })),
            react_1.default.createElement("small", { className: "message" },
                react_1.default.createElement(Markdown_1.default, { children: l('@growth.WalletSelector.trezor') }))),
        props.error && react_1.default.createElement("p", { className: "error visible" }, props.error),
        props.loading ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Loader_1.default, { size: "big", active: true, provider: props.providerType }),
            react_1.default.createElement("div", { className: "loader-background" }))) : null));
});
